module.exports = __webpack_public_path__ + "assets/assets/images/icons/phone-icon-white.8be68644.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/phone-icon-white.png
// module id = 277
// module chunks = 2